"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _replaceStringVars = _interopRequireDefault(require("../string/replaceStringVars"));
var _defaultStaticContent = _interopRequireDefault(require("./defaultStaticContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Singleton for managing access to a static content object
 * set(source) : Content object can be set from @source object
 * get(key, vars) : Returns a value based on @key and optional @vars.
 * @key = 'aKey'
 * @vars = { varPlaceholderName: 'valueToReplacePlaceholderWith'}
 * If @key value is FALSEY the key is returned
 * If @key value is a string and @vars object is provided, the string is processed with replaceStringVars
 */
var StaticContent = /*#__PURE__*/function () {
  function StaticContent() {
    _classCallCheck(this, StaticContent);
    this.content = _defaultStaticContent.default;
  }
  return _createClass(StaticContent, [{
    key: "set",
    value: function set() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // console.warn('StaticContent set:', source);

      if (!(0, _isPlainObject.default)(source)) {
        console.error('Expected object with key value pairs');
        return;
      }
      this.content = Object.assign({}, _defaultStaticContent.default, source);
    }
  }, {
    key: "get",
    value: function get(key, vars) {
      var hasVars = (0, _isPlainObject.default)(vars);

      // if no value use the key
      var content = this.content[key];
      if (content && (0, _isString.default)(content)) {
        // replace any string vars if supplied
        return hasVars ? (0, _replaceStringVars.default)(content, vars) : content;
      }
      throw new Error("Static Content key cannot be found: ".concat(key));
    }
  }, {
    key: "add",
    value: function add() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.content = Object.assign(this.content, source);
    }
  }, {
    key: "getContent",
    value: function getContent() {
      return this.content;
    }
  }]);
}();
var _default = exports.default = new StaticContent();